import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogUrl?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
  canonical?: string;
  noindex?: boolean;
}

const SEOHelmet: React.FC<SEOProps> = ({
  title = 'Vijay Thumma – Java Full Stack Developer | Spring Boot & React Expert',
  description = 'Full Stack Developer skilled in Java, Spring Boot, React, and Microservices. Building scalable cloud-native applications with clean architecture. 8+ years experience in enterprise application development, AWS cloud deployment, and modern web technologies.',
  keywords = 'Vijay Thumma, Java Full Stack Developer, Spring Boot Developer, React Developer, Software Engineer, Full Stack Engineer, Backend Developer, Frontend Developer, Spring Boot Microservices Developer, REST API Developer, AWS Cloud Engineer, Microservices Architecture, Docker and Kubernetes Developer',
  ogTitle,
  ogDescription,
  ogImage = 'https://www.vthumma.com/images/large/about-pic.webp',
  ogUrl = 'https://www.vthumma.com/',
  twitterTitle,
  twitterDescription,
  twitterImage,
  canonical = 'https://www.vthumma.com/',
  noindex = false,
}) => {
  const finalOgTitle = ogTitle || title;
  const finalOgDescription = ogDescription || description;
  const finalTwitterTitle = twitterTitle || title;
  const finalTwitterDescription = twitterDescription || description;
  const finalTwitterImage = twitterImage || ogImage;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonical} />
      
      {/* Robots */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={finalOgTitle} />
      <meta property="og:site_name" content="Vijay Thumma - Portfolio" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={ogUrl} />
      <meta name="twitter:title" content={finalTwitterTitle} />
      <meta name="twitter:description" content={finalTwitterDescription} />
      <meta name="twitter:image" content={finalTwitterImage} />
      <meta name="twitter:image:alt" content={finalTwitterTitle} />
    </Helmet>
  );
};

export default SEOHelmet;
